import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/products/$id/')({
	loader: ({ params }) => redirect({ to: '/products/$id/analytics', params }),
});
